/**
 * @generated SignedSource<<765fb3035daa4309c212946b20d91a28>>
 * @lightSyntaxTransform
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ToolButtons_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "toolProject",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "message",
                  "storageKey": null
                }
              ],
              "type": "Error",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Tool",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserLoggedInButtons_Fragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserNotLoggedInButtons_Fragment"
    }
  ],
  "type": "ToolInterface",
  "abstractKey": "__isToolInterface"
};

node.hash = "8718866c1bd34ea0a39e820fc5adb6ec";

export default node;
